import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import api from '../services/api';
import './AtualizacoesModal.css';

const nomes = { NOVO: 'Novo', MELHORIA: 'Melhoria', CORRECAO: 'Correção', IMPORTANTE: 'Importante' };

export default function AtualizacoesModal() {
  const { token } = useContext(AuthContext);
  const [pendentes, setPendentes] = useState([]);
  const [confirmando, setConfirmando] = useState(false);

  useEffect(() => {
    let ativo = true;
    if (!token) { setPendentes([]); return undefined; }
    api.get('/atualizacoes-sistema/pendentes')
      .then(({ data }) => ativo && setPendentes(Array.isArray(data) ? data : []))
      .catch(() => ativo && setPendentes([]));
    return () => { ativo = false; };
  }, [token]);

  const atualizacao = pendentes[0];
  if (!atualizacao) return null;

  const confirmar = async () => {
    try {
      setConfirmando(true);
      await api.post(`/atualizacoes-sistema/${atualizacao.id}/visualizacoes`);
      setPendentes((lista) => lista.slice(1));
    } finally { setConfirmando(false); }
  };

  return <div className="news-overlay" role="dialog" aria-modal="true" aria-labelledby="news-title">
    <section className="news-modal">
      <div className="news-hero">
        <span className="news-kicker"><i className="bi bi-stars" /> Novidades do Cultiva+</span>
        <h2 id="news-title">{atualizacao.titulo}</h2>
        <div className="news-version">Versão {atualizacao.versao}</div>
        {atualizacao.descricao && <p>{atualizacao.descricao}</p>}
      </div>
      <div className="news-body">
        {atualizacao.itens.map((item) => <article className={`news-item ${item.tipo.toLowerCase()}`} key={item.id || `${item.tipo}-${item.ordem}`}>
          <span className="news-type">{nomes[item.tipo] || item.tipo}</span>
          <div><h3>{item.titulo}</h3>{item.descricao && <><small className="news-detail-label">O que mudou na prática</small><p>{item.descricao}</p></>}</div>
        </article>)}
      </div>
      <footer className="news-footer">
        {pendentes.length > 1 && <small>{pendentes.length} comunicados não visualizados</small>}
        <button type="button" onClick={confirmar} disabled={confirmando} className="news-confirm">
          {confirmando ? 'Registrando...' : 'Entendi, continuar'} <i className="bi bi-arrow-right" />
        </button>
      </footer>
    </section>
  </div>;
}
